@if (isModalShown && commonDataService.user.isAdmin) {
    <div
        [config]="{ show: true }"
        (onHidden)="onHidden()"
        bsModal
        #autoShownModal="bs-modal"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="dialog-auto-name">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <button
                        type="button"
                        class="btn btn-icon btn-close btn-transparent close"
                        aria-label="Close"
                        (click)="hideModal()">
                        <sb-inline-svg
                            class="icon icon-close"
                            aria-label="My icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
                    </button>
                    <img src="../../../../assets/images/onboarding.png" />
                    <h2 class="text-center" translate>Welcome to Socialboards - we're happy you are here.</h2>
                    @if (socialMediaStatuses.facebook || socialMediaStatuses.instagram) {
                        <div class="mt-2">
                            <p translate>
                                Messages from your customers are downloading as we speak, great work so far!
                            </p>
                            <a [href]="adminUrlBase + 'community/widgets'" translate>Install chat,</a>&nbsp;<a
                                [href]="adminUrlBase + 'community/forms/new/general'"
                                translate
                                >create webforms,</a
                            >&nbsp;<a [href]="adminUrlBase + 'community/teammates'" translate>add users</a>&nbsp;<span
                                translate
                                >and more in</span
                            >&nbsp;<a [href]="adminUrlBase + 'home'" translate>the setup section.</a>
                        </div>
                    } @else {
                        <div class="mt-2">
                            <p class="text-center" translate>
                                To start supporting your customers, please connect to one of the following accounts:
                            </p>
                            <div class="text-center mb-2">
                                <button
                                    class="btn social-btn btn-md btn-facebook"
                                    (click)="openInstallationPage('facebook')">
                                    <span translate>Facebook</span>
                                </button>
                                <button
                                    class="btn social-btn btn-md btn-instagram"
                                    (click)="openInstallationPage('instagram')">
                                    <span translate>Instagram</span>
                                </button>
                            </div>
                            <a [href]="adminUrlBase + 'community/widgets'" translate>Add Chat,</a>&nbsp;<a
                                [href]="adminUrlBase + 'community/forms/new/general'"
                                translate
                                >Webforms,</a
                            >&nbsp;<a [href]="adminUrlBase + 'community/installation/emails'" translate>Emails</a
                            >&nbsp;<span translate>and</span>&nbsp;<a
                                [href]="adminUrlBase + 'community/installation/'"
                                translate
                                >other channels</a
                            >&nbsp;<span translate>in the setup section.</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
